import React, { useEffect, useState, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FormWrapper from "../FormWrapper";

import { useToastMessage } from "../../../components/ToastMessage/ToastMessage";
import { Toaster } from "@fluentui/react-components";
import { FormLoader } from "../../../components/Loader/FormLoader";
import { TableListLoader } from "../../../components/Loader/TableListLoader";
import ListWrapper from "../ListWrapper";
import { configFm } from "../../../types";
import { AppDispatch, RootState } from "../../../redux/store";
import {
  getUsersListItems,
  getUserDetailById,
} from "../../../redux/SystemManager/manageUser";
import ManageUserFormContainer from "./ManageUserFormContainer";
import apiServices from "../../../service";
import { useActiveRecordSync } from "../../../components/useActiveRecordSync";
const FORM_CONTEXT = "SYSTEM_MANAGER_USERLIST";
const API_BASE_PATH = "/system-manager/manage-user";
function ManageUserDetailPage() {
  const { userId, action } = useParams();
  const location = useLocation();
  const { showToast, toasterId } = useToastMessage();
  const navigate = useNavigate();
  const [permissionsList, setPermissionsList] = useState<any>([]);
  const [compositeRoles, setCompositeRoles] = useState<any>([]);
  const dispatch: AppDispatch = useDispatch();
  const { activeItem, listItems, loading, activeItemloading } = useSelector(
    (state: RootState) => state.manageUser
  );
  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const [configForm, setConfigForm] = useState<configFm>();
  const [currentRecord, setCurrentRecord] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState<{
    [key: string]: any;
  }>({});
  useEffect(() => {
    dispatch(getUsersListItems());
    getUserPermissions();
  }, [dispatch]);
  useEffect(() => {
    if (listItems.length > 0 && userId) {
      dispatch(getUserDetailById(userId));
    }
  }, [listItems, userId, dispatch]);
  // The effect above only refreshes `activeItem` when the URL carries a
  // userId -- deleting the currently-viewed user left activeItem stuck at
  // {} forever since nothing re-checked it against the refreshed list.
  // Re-check on every list change and redirect to a real user's own id,
  // same fix as VulnerabilityDetailPage.tsx.
  useActiveRecordSync({
    listItems,
    idKey: "user_id",
    selectedId: userId,
    loading: loading || action === "add",
    onSelect: (item) =>
      navigate(`${API_BASE_PATH}/${item.user_id}/${action || "view"}`, {
        replace: true,
      }),
    onEmpty: () => navigate(API_BASE_PATH, { replace: true }),
  });
  useEffect(() => {
    if (
      formSettingsObj?.systemAdmin &&
      formSettingsObj.systemAdmin.formConfig !== undefined
    ) {
      let configObj = formSettingsObj.systemAdmin.formConfig.find(
        (item: any) => item.context === FORM_CONTEXT
      );
      if (configObj) {
        setConfigForm(configObj);
      }
    }
  }, [formSettingsObj]);

  const loadData = async (
    dispatch: AppDispatch,
    id?: string
  ): Promise<void> => {
    await dispatch(getUsersListItems());
    if (id) {
      await dispatch(getUserDetailById(id));
    }
  };
  const getUserPermissions = async () => {
    setIsLoading(true);
    try {
      const response =
        await apiServices.systemManager.manageUsers.getPermissions();
      if (response && response.data && response.data.data.length > 0) {
        const compositeRoles = response.data.data.filter(
          (role: any) => role.composite === true
        );
        setCompositeRoles(compositeRoles);
        setPermissionsList(response.data.data);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };
  const hasListItems = useMemo(() => listItems.length > 0, [listItems]);
  return (
    <>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <div className="user_container_flex">
        {action &&
          (activeItemloading ? (
            <FormLoader />
          ) : (
            <ManageUserFormContainer
              context={FORM_CONTEXT}
              config={configForm}
              notify={showToast}
              isFormAdmin={true}
              dataList={listItems}
              reloadData={loadData}
              permissionsList={permissionsList}
              compositeRoles={compositeRoles}
              setSelectedUserData={setSelectedUserData}
              selectedRowItem={activeItem}
              action={action || "view"}
              apiPath={API_BASE_PATH}
              activeRow={currentRecord}
            />
          ))}

        {loading ? (
          <TableListLoader rows={8} columns={6} />
        ) : (
          hasListItems &&
          action &&
          listItems.length > 0 && (
            <ListWrapper
              data={listItems}
              context={FORM_CONTEXT}
              selectedRowItem={activeItem}
              onRowAction={(action, row) => {
                navigate(
                  `${API_BASE_PATH}/${row?.user_id}/${action || "view"}`
                );
              }}
              currentRecord={(index: any) => setCurrentRecord(index)}
            />
          )
        )}
      </div>
    </>
  );
}

export default ManageUserDetailPage;
